import { gql } from '@apollo/client'

export const GET_USER_CERTIFICATES = gql`
  query getUserCertificates($offset: Int!, $limit: Int!) {
    userCertificates(
      pagination: { limit: $limit, offset: $offset }
      ordenation: { by: "id", direction: "desc" }
    ) {
      id
      fileUrl
      createdAt
      updatedAt
      courseId
      token
      schoolProduct {
        id
        title
        logo
      }
      course {
        id
        name
        imageUrl
      }
    }
  }
`
